var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.403,
    height: 44.213,
    viewBox: "0 0 35.403 44.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M72.8,85.4H52.16a3.512,3.512,0,0,0-3.51,3.51v29.62a3.512,3.512,0,0,0,3.51,3.51H72.8a3.512,3.512,0,0,0,3.51-3.51V88.91A3.524,3.524,0,0,0,72.8,85.4Zm1.046,33.121a1.056,1.056,0,0,1-1.055,1.055H52.151a1.056,1.056,0,0,1-1.055-1.055V88.91a1.056,1.056,0,0,1,1.055-1.055H72.795A1.056,1.056,0,0,1,73.85,88.91Z",
    transform: "translate(-48.65 -77.827)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M159.6,0H138.96a3.512,3.512,0,0,0-3.51,3.51,1.228,1.228,0,0,0,2.455,0,1.056,1.056,0,0,1,1.055-1.055H159.6a1.056,1.056,0,0,1,1.055,1.055V33.13a1.056,1.056,0,0,1-1.055,1.055,1.228,1.228,0,0,0,0,2.455,3.512,3.512,0,0,0,3.51-3.51V3.51A3.512,3.512,0,0,0,159.6,0Z",
    transform: "translate(-127.711)",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.09cce9455b2f002a6aebe30e682639cb.svg";
export { ForwardRef as ReactComponent };